// extracted by mini-css-extract-plugin
export default {"qrColor":"#362044","mainMapPage":"main-map-page_mainMapPage__atdR4"};